import { Typography } from "@povio/ui";
import clsx from "clsx";

import { DogHexagonFrameIcon } from "@/assets/icons/general/DogHexagonFrame";

const MobileBlocker = () => {
  return (
    <div className="fixed top-0 right-0 bottom-0 z-50 flex w-full items-center justify-center gap-4 p-4 backdrop-blur-7">
      <div className="relative z-9999 mx-auto flex flex-col items-center">
        {/* Dog Character */}
        <div className="relative shrink-0">
          {/* Hexagon Frame Background */}
          <DogHexagonFrameIcon className={clsx("z-10 h-[362px] w-[326px]")} />
        </div>

        {/* Speech Bubble Container */}
        <div className="relative flex -translate-y-14 flex-col">
          {/* Speech Bubble */}
          <div className="relative flex w-[289px] flex-col gap-[11px] rounded-[22px] bg-primary-50 pt-12 pr-5 pb-4 pl-6 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.3)]">
            <Typography
              size="title-2"
              className="font-boyrun! text-black leading-[26px]!"
            >
              We're not on mobile yet — but we're getting there!
            </Typography>
            <Typography
              size="body-2"
              className="font-boyrun! text-black leading-[26px]!"
            >
              Our mobile version is in the works and coming soon — sit tight, we'll be ready before you know it.
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileBlocker;
